//Performs a smooth page scroll to an anchor on the same page.
//Gets overriden by barba if it's not on the same page...
//Generell musste ich barba beibringen korrekt mit anchor links umzugehen... Bei neueren Versionen funktioniert das out of the box
$(document).on('click', '.main-nav__link', function(e){
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $(e.target.hash).offset().top
    }, 800);
});